import React from 'react';
import type { RealestateAd, RealestateProjectAd } from '../../../types';
import { useSearchAdContext } from '../SearchAdContext';
import type { LabelRenderProps } from '../SearchAdPrimaryLabel';
import { SearchAdPrimaryLabel } from '../SearchAdPrimaryLabel';

const sortedLabelIds = ['viewingtoday', 'sold', 'rentedout', 'coming_for_sale'];

type RealestateLabelProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
    label?: (props: LabelRenderProps) => React.ReactElement | null;
};

export function RealestateLabel(props: RealestateLabelProps) {
    const { ad, className, label } = props;

    return (
        <SearchAdPrimaryLabel
            ad={ad}
            className={className}
            labelIds={sortedLabelIds}
            render={label ?? renderRealestateLabel}
        />
    );
}

function renderRealestateLabel({
    className = '',
    classes,
    label,
}: LabelRenderProps) {
    if (!label) {
        return null;
    }

    return (
        <>
            {label.id === 'sold' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'rentedout' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'coming_for_sale' && (
                <span
                    className={`${className} ${classes.badge} ${classes.info}`}
                >
                    {label.text}
                </span>
            )}
        </>
    );
}

export function BasicRealestateLabel(props: RealestateLabelProps) {
    const { ad, className = '', label } = props;

    const { mode } = useSearchAdContext();
    const basicLabelClass = mode === 'mobile' ? '' : 'sm:rounded-tl-0';
    const baseClass = `${className} ${basicLabelClass}`;

    return (
        <SearchAdPrimaryLabel
            ad={ad}
            className={baseClass}
            labelIds={sortedLabelIds}
            render={label ?? renderBasicRealestateLabel}
        />
    );
}

function renderBasicRealestateLabel({
    className = '',
    classes,
    label,
}: LabelRenderProps) {
    if (!label) {
        return null;
    }

    return (
        <>
            {label.id === 'viewingtoday' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'sold' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'rentedout' && (
                <span
                    className={`${className} ${classes.badge} ${classes.warning}`}
                >
                    {label.text}
                </span>
            )}
            {label.id === 'coming_for_sale' && (
                <span
                    className={`${className} ${classes.badge} ${classes.info}`}
                >
                    {label.text}
                </span>
            )}
        </>
    );
}
